import { Component, OnInit } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { WirePageBuilderService } from '../../services/wire-page-builder.service';

@Component({
    selector: 'agpr-wire-preview-dialog',
    templateUrl: './wire-preview-dialog.component.html',
    styleUrls: ['./wire-preview-dialog.component.scss'],
    standalone: false
})
export class WirePreviewDialogComponent extends AbstractDialogComponent implements OnInit {
    headerHtml: string;
    logoHtml: string;
    body: string;

    constructor(
        public coreDialogService: CoreDialogService,
        public wirePageBuilderService: WirePageBuilderService
    ) {
        super(coreDialogService, 'WirePreview');
    }

    ngOnInit() {
        this.headerHtml = this.wirePageBuilderService.getWireHeaderHtml();
        this.logoHtml = this.wirePageBuilderService.getCompanyLogoHtml();
        this.body = this.wirePageBuilderService.getWireHtml();
    }
}
